import { useEffect, useRef } from 'react';
import { Button, Portal } from '@nazka/nazka.mapframe.components';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';

import { useOnClickOutside } from '@services/hooks.service';

import './modal.css';

function Modal({
  isOpen,
  onClose,
  children,
  title,
  className,
  showCloseButton = true,
  closeOnOverlayClick = true,
  closeOnEscape = true,
  maxWidth,
}) {
  const modalContentRef = useRef(null);

  useEffect(() => {
    if (!isOpen || !closeOnEscape) return;

    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose, closeOnEscape]);

  useOnClickOutside(modalContentRef, () => {
    if (closeOnOverlayClick) {
      onClose();
    }
  });

  if (!isOpen) {
    return null;
  }

  return (
    <Portal>
      <div className="modal">
        <div
          ref={modalContentRef}
          className={`modal__content ${className || ''}`}
          style={maxWidth ? { maxWidth } : { maxWidth: '600px' }}
        >
          {(title || showCloseButton) && (
            <div className="modal__content__header">
              {title && <h2 className="modal__content__header__title">{title}</h2>}
              {showCloseButton && (
                <Button
                  className="modal__content__header__close"
                  onClick={onClose}
                  icon={faXmark}
                  layout="ghost"
                  color="black"
                  hover={false}
                />
              )}
            </div>
          )}
          <div className="modal__content__body">
            {children}
          </div>
        </div>
      </div>
    </Portal>
  );
}

export default Modal;
